export var FeatureRankingType;
(function (FeatureRankingType) {
    FeatureRankingType["PLANNED"] = "planned";
    FeatureRankingType["IN_PROGRESS"] = "inProgress";
    FeatureRankingType["COMPLETE"] = "complete";
})(FeatureRankingType || (FeatureRankingType = {}));
//# sourceMappingURL=feature-ranking-type.enum.js.map